// extracted by mini-css-extract-plugin
export var centerText = "_eb-8";
export var container = "_eb-0";
export var doughnutContainer = "_eb-7";
export var legend = "_eb-a";
export var legendItemColorDisplay = "_eb-b";
export var legendItemLabel = "_eb-d";
export var legendItemValue = "_eb-c";
export var lg = "_eb-5";
export var maxWidth = "_eb-9";
export var md = "_eb-4";
export var responsive = "_eb-6";
export var sm = "_eb-3";
export var xs = "_eb-2";
export var xxs = "_eb-1";